import VerifyPageBody from "../components/verifyPage/VerifyPageBody";

const VerifyPage = () => {
    return(
        <VerifyPageBody/>
    )
}

export default VerifyPage;